export default function makeBasicGalleryMarkup() {
  return `
  <main>
    <section class="section gallery__section">
    <div class="container">
    <div class="filter__wrap"></div>
      
        <h2 class="gallery__title visually-hidden">Gallery list</h2>
        <ul class="gallery"></ul>
        <div class="pagination">
        
    </section>
  </main>`;
}
